import { useCallback, useEffect, useRef } from 'react';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
const SUB_PIXEL_SHIFT = 0.25;
const INITIAL_OVERLAP = -11;
const INITIAL_START_Y = -5;
export const useStripeSetAnimation = ({ intersectionRef, ref, alignEnd })=>{
    const overlap = useRef(INITIAL_OVERLAP);
    const startY = useRef(INITIAL_START_Y);
    const windowHeight = useRef(0);
    const stripes = useRef([]);
    const intersectionShiftY = useRef(0);
    const shiftY = useRef(0);
    const elementBottomPosition = useRef(0);
    const handleScroll = useCallback(()=>{
        if (!ref.current) {
            return;
        }
        const scrollTop = window.scrollY;
        const progress = (windowHeight.current - (elementBottomPosition.current - scrollTop)) / windowHeight.current;
        const shiftingStripes = alignEnd ? [
            stripes.current[0],
            stripes.current[2]
        ] : [
            stripes.current[1]
        ];
        const scrollShiftY = Math.round(startY.current + overlap.current * progress * 2) / 2;
        const scrollIntersectionShiftY = alignEnd ? -scrollShiftY : scrollShiftY;
        if (scrollIntersectionShiftY !== intersectionShiftY.current && intersectionRef.current) {
            intersectionRef.current.style.transform = `translateY(${scrollIntersectionShiftY - SUB_PIXEL_SHIFT}px)`;
            intersectionShiftY.current = scrollIntersectionShiftY;
        }
        if (scrollShiftY !== shiftY.current) {
            shiftingStripes.forEach((el)=>{
                el.style.transform = `translateY(${scrollShiftY}px)`;
            });
            shiftY.current = scrollShiftY;
        }
    }, [
        alignEnd,
        intersectionRef,
        ref
    ]);
    const handleResize = useCallback(()=>{
        windowHeight.current = window.innerHeight;
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            elementBottomPosition.current = rect.bottom + window.scrollY;
        }
        handleScroll();
    }, [
        handleScroll,
        windowHeight,
        ref
    ]);
    useEffect(()=>{
        if (!ref || !ref.current) {
            return;
        }
        stripes.current = Array.from(ref.current.children || []);
        if (stripes.current.length <= 1) {
            return;
        }
        if (alignEnd) {
            overlap.current *= -1;
            startY.current *= -1;
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return ()=>window.removeEventListener('resize', handleResize);
    }, [
        handleResize,
        ref,
        alignEnd
    ]);
    useIntersectionObserver({
        node: ref,
        threshold: 0.01,
        disabled: false,
        handler: useCallback((entry)=>{
            if (entry.isIntersecting && stripes.current.length > 1) {
                window.addEventListener('scroll', handleScroll);
            } else if (stripes.current.length > 1) {
                window.removeEventListener('scroll', handleScroll);
            }
        }, [
            handleScroll
        ])
    });
};

//# sourceMappingURL=useStripeSetAnimation.js.map